import { render, staticRenderFns } from "./TList.vue?vue&type=template&id=4f310b1e&scoped=true"
import script from "./TList.vue?vue&type=script&lang=js"
export * from "./TList.vue?vue&type=script&lang=js"
import style0 from "./TList.vue?vue&type=style&index=0&id=4f310b1e&prod&lang=scss"
import style1 from "./TList.vue?vue&type=style&index=1&id=4f310b1e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f310b1e",
  null
  
)

export default component.exports